var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-linkedin-3 1",
    clipPath: "url(#clip0_43_2026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.7083 0.5H7.29167C3.26521 0.5 0 3.76521 0 7.79167V28.2083C0 32.2348 3.26521 35.5 7.29167 35.5H27.7083C31.7363 35.5 35 32.2348 35 28.2083V7.79167C35 3.76521 31.7363 0.5 27.7083 0.5ZM11.6667 28.2083H7.29167V12.1667H11.6667V28.2083ZM9.47917 10.3175C8.07042 10.3175 6.92708 9.16542 6.92708 7.745C6.92708 6.32458 8.07042 5.1725 9.47917 5.1725C10.8879 5.1725 12.0312 6.32458 12.0312 7.745C12.0312 9.16542 10.8894 10.3175 9.47917 10.3175ZM29.1667 28.2083H24.7917V20.0358C24.7917 15.1242 18.9583 15.496 18.9583 20.0358V28.2083H14.5833V12.1667H18.9583V14.7406C20.9942 10.9694 29.1667 10.6908 29.1667 18.3515V28.2083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_2026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b02c49d6bffc249e837d4b09d74e3372.svg";
export { ForwardRef as ReactComponent };